import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import styles from "./BannerAdmin.module.css";
import { AxiosInstance } from "../../../../../../axios";
import toast from "react-hot-toast";
import Loader from "../../../../Loader";
import moment from "moment";
import DatePickerSample from "../../../../DatePicker";
import { ImageUrlPrefix } from "../../../../../../labels";
import { Download } from "@mui/icons-material";
import dayjs from "dayjs";

export default function AddBannerAdminInfo(props) {
  const { id } = useParams();
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id not available in session storage");
  }
  const [selectedImage, setSelectedImage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({});
  const [imageFilesUploadedList, setImageFilesUploadedList] = useState([]);
  const [fileError, setFileError] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const navigate = useNavigate();
  const [visibleImage, setVisibleImage] = useState(false);
  const [initialfields, setInitialfields] = useState({
    id: "",
    banner_path: "",
    original_banner_path: "",
    start_date: "",
    end_date: "",
    created_dt: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    created_by: userid || "",
    display_option: 1,
    is_deleted: 0,
  });

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFileError("");
    if (!file) {
      setFileError("Please select slide image");
      setInitialfields((prevFields) => ({
        ...prevFields,
        banner_path: "",
        original_banner_path: "",
      }));
      return;
    }
    if (!file.type.startsWith("image/")) {
      setFileError("Only image files are allowed");
      return;
    }
    if (file.size > 2 * 1024 * 1024) {
      setFileError("The file must be less than 2MB");
      return;
    }
    setInitialfields((prevFields) => ({
      ...prevFields,
      banner_path: file.name,
      original_banner_path: file.name,
    }));
    setError((prevError) => {
      const { banner_path, ...restErrors } = prevError;
      return restErrors;
    });
    setSelectedFiles([file]);
  };

  const handleDateChange = (date, fieldName) => {
    if (!date) return;
    const dateDOB = moment(date).format("YYYY-MM-DD");
    if (fieldName === "start_date" || fieldName === "end_date") {
      const from = fieldName === "start_date" ? dateDOB : initialfields.start_date;
      const to = fieldName === "end_date" ? dateDOB : initialfields.end_date;
      if (fieldName === "end_date" && moment(to).isBefore(moment(from))) {
        setInitialfields({
          ...initialfields,
          [fieldName]: dateDOB,
        });
        setError((prev) => ({
          ...prev,
          end_date: "Visible To date cannot be earlier than Visible From date",
        }));
        return;
      }
      if (fieldName === "start_date" && moment(from).isAfter(moment(to)) && to) {
        setInitialfields({
          ...initialfields,
          [fieldName]: dateDOB,
        });
        setError((prev) => ({
          ...prev,
          start_date: "Visible From date cannot be later than Visible To date",
        }));
        return;
      }
    }
    setInitialfields({
      ...initialfields,
      [fieldName]: dateDOB,
    });
    setError((prev) => ({
      ...prev,
      [fieldName]: "",
    }));
  };


  useEffect(() => {
    if (selectedFiles?.length > 0) {
      const uploadPromises = selectedFiles?.map((file) => {
        const formData = new FormData();
        formData.append("gallery_image", file);
        return AxiosInstance.post("api/upload/", formData)
          .then((response) => {
            const { path, originalname } = response?.data?.path[0];
            return { path: path, originalname: originalname };
          })
          .catch((error) => {
            console.error("Error uploading file:", error);
            return null;
          });
      });
      Promise.all(uploadPromises)
        .then((uploadedFiles) => {
          const validUploadedFiles = uploadedFiles.filter(
            (file) => file !== null
          );
          setImageFilesUploadedList((prevList) => [
            ...prevList,
            ...validUploadedFiles,
          ]);
        })
        .catch((error) => {
          console.error("Error in batch upload:", error);
        });
    }
  }, [selectedFiles]);
  useEffect(() => {
    const folderPayloadImage = {
      is_admin: 1,
      page: "",
      page_size: "",
    };
    AxiosInstance.post("/api/gallery/banner/list", folderPayloadImage)
      .then((res) => {
        if (id) {
          let imageData = res?.data?.data?.filter(
            (item) => item.id === parseInt(id)
          );
          setVisibleImage(
            imageData[0]?.display_option === 1
              ? "yes"
              : imageData[0]?.display_option === 0
                ? "no"
                : null
          );
          setInitialfields((prev) => ({
            ...prev,
            id: imageData[0]?.id,
            start_date: moment(imageData[0]?.start_date).format("YYYY-MM-DD"),
            end_date: moment(imageData[0]?.end_date).format("YYYY-MM-DD"),
            original_banner_path: imageData[0]?.original_banner_path,
          }));
          console.log("2. Image Data for Edit:", imageData[0]);
          console.log("3. Selected Image State Before Setting:", selectedImage);
          setSelectedImage(imageData[0]);
        }
      })
      .catch((error) => {
        return error;
      })
  }, []);


  const handleImageUploadFinal = async () => {
    // Prepare the final payload object using ternary operator
    let finalObj = id
      ? {
        // If editing an existing banner
        ...initialfields,
        id: selectedImage.id,
        display_option: visibleImage === "yes" ? 1 : 0,
        banner_path: selectedImage.banner_path,
        start_date: moment(
          selectedImage?.start_date || initialfields.start_date
        ).format("YYYY-MM-DD"),
        end_date: moment(
          selectedImage?.end_date || initialfields.end_date
        ).format("YYYY-MM-DD"),
        is_deleted: 0,
        original_banner_path: selectedImage.original_banner_path,
      }
      : imageFilesUploadedList.length > 0
        ? {
          // If adding a new banner and files are available
          ...initialfields,
          banner_path: imageFilesUploadedList[0].path,
          original_banner_path: imageFilesUploadedList[0].originalname,
        }
        : (console.error("No uploaded files available to create the banner"), {}); // Error handling if no files are present

    // if (Object.keys(finalObj).length === 0) return; // If finalObj is empty (i.e., no files available for new banner)

    console.log("1 : Final Payload for API:", finalObj);

    // Make the API call to add/edit the banner
    try {
      const res = await AxiosInstance.post(`/api/gallery/banner/add`, finalObj);

      if (res.status === 200) {
        toast.success(res.data.message);
        navigate("/ViewBannerAdmin");
      } else {
        toast.error(res.data.message);
      }

      // Reset state
      setImageFilesUploadedList([]);
      setSelectedFiles([]);
      setInitialfields({
        id: "",
        banner_path: "",
        original_banner_path: "",
        display_option: 1,
        created_dt: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        created_by: userid || "",
        is_deleted: 0,
      });
      // handleMapNewFolderNames();
    } catch (error) {
      console.error("Error saving banner:", error);
    }
  };

  const handleDownloadImages = async () => {
    if (imageFilesUploadedList.length > 0) {
      for (let i = 0; i < imageFilesUploadedList.length; i++) {
        const image = imageFilesUploadedList[i];
        const imagePath = `${ImageUrlPrefix}/${image.path}`;
        try {
          const response = await fetch(imagePath);
          if (!response.ok) {
            throw new Error(`Failed to fetch image: ${imagePath}`);
          }
          const imageBlob = await response.blob();
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(imageBlob);
          downloadLink.download = image.path.split("/").pop();
          downloadLink.click();
        } catch (error) {
          console.error(`Error fetching image from path ${imagePath}:`, error);
        }
      }
    } else {
      console.log("No images to download.");
    }
  };

  const handleSubmit = () => {
    const errors = validateFields(initialfields);
    console.log(errors, "handle submit errors");
    if (Object.keys(errors).length === 0) {
      try {
        handleImageUploadFinal();
      } catch (error) {
        console.log(error);
      }
    } else {
      setError(errors);
    }
  };
  const banner_path_ref = useRef(null);
  const display_start_date_ref = useRef(null);
  const display_end_date_ref = useRef(null);
  const validateFields = (data, suTopics) => {
    const errors = {};
    const today = moment().format("YYYY-MM-DD");
    if (!id) {
      if (selectedFiles.length === 0) {
        setFileError("Please select slide image");
      }
    }
    if (!data.start_date) {
      errors.start_date = "Please select Visible From date";
    }
    //  else if (moment(data.start_date).isBefore(today)) {
    //   errors.start_date = " Visible From date cannot be earlier than today";
    // }
    if (!data.end_date) {
      errors.end_date = "Please select Visible To date";
    }
    if (data.start_date && data.end_date) {
      const startDate = new Date(data.start_date);
      const endDate = new Date(data.end_date);
      if (endDate <= startDate) {
        errors.end_date = "Visible To date must be after Visible From date";
      }
    }
    return errors;
  };

  const navigateToPreviousScreen = () => {
    navigate(-1);
  };
  const futureDate = moment().add(0, "days");
  const isExpired = initialfields.end_date && new Date(initialfields.end_date) < new Date();
  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className={`${styles.GalleryInfoSec} BathHeader global_container`}>
      <div className="row">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader">
            {id ? "Edit Slide" : "Add New Slide"}
          </h2>
        </div>
        <div className="col-md-6 col-12 ListBtn">
          <ul className="List-Button">
            <li className="ListBtnItems">
              <Link
                to={id ? "javascript:void(0)" : "/ViewBannerAdmin"}
                onClick={id ? navigateToPreviousScreen : () => { }}
                className="secondaryButton "
                variant="secondary"
              >
                {id ? "Back to Slides" : "Back to Slides"}
              </Link>
            </li>
            <li className="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={handleSubmit}
                className="primaryButton text-center "
                variant="primary"
              >
                Save Slide
              </Link>
            </li>
          </ul>
        </div>
        <div className="row m-0 mb-4">
          <fieldset className="mt-3">
            <legend className="w-auto">Slide Details</legend>
            <form className="row g-3">
              {/* Upload */}
              <div className="col-lg-6 col-md-12">
                <div className="forms ">
                  <div className="d-flex">
                    <div className="row">
                      <label
                        for="formFile"
                        class={
                          id
                            ? "form-label confirm_value disabled_btn"
                            : "form-label confirm_value "
                        }
                      >
                        Upload Slide (Max 2MB)
                      </label>
                    </div>
                    {initialfields.bannerImg !== "" &&
                      initialfields.bannerImg !== null && (
                        <div
                          className={
                            id
                              ? ` ${styles.disabled}`
                              : "d-flex align-content-center p-0"
                          }
                        >
                          {id
                            ? null
                            : imageFilesUploadedList.length > 0 && (
                              <>
                                <a onClick={handleDownloadImages}>
                                  <Download className="download_icon" />
                                </a>
                              </>
                            )}
                        </div>
                      )}
                  </div>
                  <div className="row">
                    <div
                      className={
                        initialfields.original_banner_path
                          ? "col-md-3 col-5 "
                          : "col-md-12"
                      }
                    >
                      {/* <input
                        className={`InputsSelectFile ${id ? "nn_upload_width" : "vv_upload_width"
                          }`}
                        placeholder="Select file"
                        disabled={id ? true : false}
                        ref={banner_path_ref}
                        type="file"
                        required
                        id="bannerImg"
                        onChange={handleFileChange}
                        accept=".jpg,.jpeg,.png"
                        name="bannerImg"
                      /> */}

                      <input
                        type="file"
                        className={`InputsSelectFile ${id ? "nn_upload_width" : "vv_upload_width"
                          }`}
                        ref={banner_path_ref}
                        disabled={id ? true : false}
                        placeholder="Select image"
                        required
                        id="bannerImg"
                        name="bannerImg"
                        accept=".jpg,.jpeg,.png"
                        onChange={handleFileChange}
                      />





                    </div>
                    {initialfields.original_banner_path && (
                      <div
                        className={
                          "col-md-9 col-7 d-flex align-content-center p-0"
                        }
                      >
                        <span className={styles.nn_upload_fileevaluator}>
                          {initialfields.original_banner_path}
                        </span>

                        <>
                          <span
                            className={`${styles.verified_uploadeval} material-icons align-middle`}
                          >
                            verified
                          </span>
                        </>
                      </div>
                    )}
                  </div>

                  {fileError && (
                    <small className="error_message">{fileError}</small>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <label
                  htmlFor="Visible From"
                  className="form-label confirm_value pb-2"
                >
                  Visible From
                </label>
                <DatePickerSample
                  txtAdMDob={display_start_date_ref}
                  handleChange={(date) => handleDateChange(date, "start_date")}
                  fieldInput={initialfields.start_date}
                  minDate={futureDate}
                />
                {error.start_date && (
                  <small className="error_message">{error.start_date}</small>
                )}
              </div>

              <div className="col-md-6">
                <label
                  htmlFor="Visible To"
                  className="form-label confirm_value"
                >
                  Visible To
                </label>
                <DatePickerSample
                  txtAdMDob={display_end_date_ref}
                  handleChange={(date) => handleDateChange(date, "end_date")}
                  fieldInput={initialfields.end_date}
                  minDate={futureDate}
                // selectedDate={initialfields.end_date}
                />
                {error.end_date && (
                  <small className="error_message">{error.end_date}</small>
                )}
              </div>

              {/* Visibility Checkbox */}
              {id ? (
                <div className="col-md-6">
                  <label
                    htmlFor="Visible to Users"
                    className="form-label confirm_value"
                    isDisabled={initialfields.end_date ? true : false}
                  >
                    Visible to Users
                  </label>

                  <div>
                    <input
                      className={`shadow-none input-font-size  ${styles.checkbox_radio}`}
                      type="radio"
                      id="yes"
                      name="Visible to Users"
                      value="yes"
                      checked={visibleImage === "yes"}
                      onChange={(val) => setVisibleImage("yes")}
                      disabled={isExpired}
                    />
                    <label
                      htmlFor="yes"
                      className={`${styles.margin_right} form-label confirm_value`}
                    >
                      Yes
                    </label>

                    <input
                      // ref={optional_paper_ref}
                      className={`shadow-none input-font-size ${styles.checkbox_radio}`}
                      type="radio"
                      id="no"
                      name="is_optional"
                      disabled={isExpired}
                      // value={0}
                      value="no"
                      //  checked={initialfields.is_optional == 0 ? true : false}
                      //  onChange={handleChange}
                      checked={visibleImage === "no"}
                      onChange={(val) => setVisibleImage("no")}
                    />
                    <label htmlFor="no" className="form-label confirm_value">
                      No
                    </label>
                  </div>
                  {/* {error.is_optional && (
                 <small className={styles.errors}>
                   {error.is_optional}
                 </small>
               )} */}
                </div>
              ) : (
                <></>
              )}
            </form>
          </fieldset>
        </div>
        {/*  */}
        <div className="col-md-12 col-12 ListBtn">
          <ul className="List-Button">
            <li className="ListBtnItems">
              <Link
                to={id ? "javascript:void(0)" : "/ViewBannerAdmin"}
                onClick={id ? navigateToPreviousScreen : () => { }}
                className="secondaryButton "
                variant="secondary"
              >
                {id ? "Back to Slides" : "Back to Slides"}
              </Link>
            </li>
            <li className="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={handleSubmit}
                className="primaryButton text-center "
                variant="primary"
              >
                Save Slide
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
